<template>
    <el-dialog :visible.sync="visible" :title="'数据统计'" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
        <template>
        <el-form  :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">

            <template >
          <el-form-item label="年级" prop="gradeId">
              <el-select v-model="dataForm.gradeId" placeholder="年级">
                  <el-option
                          v-for="grade in gradeList"
                          :key="grade.id"
                          :label="grade.title"
                          :value="grade.id">
                  </el-option>
              </el-select>
          </el-form-item>
      </template>
            <template>
          <el-form-item label="月份" prop="months">
              <el-select v-model="dataForm.months" placeholder="月份">
                  <el-option
                          v-for="months in monthList"
                          :key="months.months"
                          :label="months.months+'月'"
                          :value="months.months">
                  </el-option>
              </el-select>
          </el-form-item>
      </template>

        </el-form>
            <loading :visible.sync="loading"></loading>
</template>
<!--        <template>-->
<!--            <el-checkbox-group v-model="checkedMonths"  style="margin-top: 50px">-->
<!--                <el-checkbox v-for="month in months" :label="month" :key="month">{{month}}月</el-checkbox>-->
<!--            </el-checkbox-group>-->
<!--        </template>-->
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>

    </el-dialog>
</template>
<script>
import Template from '../devtools/template'
import debounce from 'lodash/debounce'

// const cityOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
export default {
  components: { Template },
  data () {
    return {
      visible: false,
      checkAll: false,
      loading: false,
      dataForm: {
        gradeId: '',
        months: '',
        termId: ''
      },
      form: {
        termId: ''
      },
      gradeList: [],
      monthList: [],
      checkedMonths: [],
      months: ''
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getGradeList()
      this.$nextTick(() => {

      })
    },
    async  getGradeList () {
      this.$http.get('/grade/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.gradeList = res.data
        if (this.gradeList.length > 0) {
          this.dataForm.gradeId = this.gradeList[0].id
        }
        this.dataForm.termId = this.form.termId
        this.getMonthList()
      })
    },
    async   getMonthList () {
      console.log(this.form.termId)
      console.log('+++')
      const params = {
        termId: this.dataForm.termId,
        gradeId: this.dataForm.gradeId
      }
      this.$http.post('/yqtsz/ruledecoration/getMonth', params).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.monthList = res.data
        this.months = this.monthList
        if (this.monthList.length > 0) {
          this.dataForm.months = this.monthList[0].months
        }
      })
    },
    handleCheckAllChange (val) {
      this.checkedMonths = val ? this.monthList : []
      this.isIndeterminate = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      const loading = this.$loading({
        lock: true, // lock的修改符--默认是false
        text: '结果计算中，请稍候...', // 显示在加载图标下方的加载文案
        background: 'rgba(0,0,0,0.8)', // 遮罩层颜色
        spinner: 'el-icon-loading' // 自定义加载图标类名
      })
      this.loading = true
      this.$refs.dataForm.validate((valid) => {
        this.loading = true
        if (!valid) {
          return false
        }
        // this.dataForm.months = this.checkedMonths
        const params = {
          gradeId: this.dataForm.gradeId,
          months: this.dataForm.months,
          termId: this.dataForm.termId
        }
        this.$http.post('/YQtsz/yqtsztermmonthdecoration/statTermMonth', params).then(({ data: res }) => {
          loading.close()
          if (res.code !== 0) {
            loading.close()
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
